import { gql } from "@apollo/client";

export const GET_TIPO_FORMULARIO_RI_EV = gql`
query getTipoFormularioRIEV($filter: TipoFormularioRIEVFilterInput!){
    tipoFormularioRIEV (filter: $filter) {    
        success,
        error,
        valorEsperado {
            referenciaFormulario,
            idTipoFormulario,
            cantidadVisitaFormulario
        }
    }
  }
`;